export default __webpack_public_path__ + "static/media/schema-adioryx.6bdd6e12.png";